import React from 'react';
import { OptionProps } from 'react-select/lib/components/Option';
import { TRUNCATED_TEXT_TOOLTIP_DELAY_MS } from '@tanium/coreui-utils';
import { css } from '@tanium/react-emotion-9';
import { Modifiers, SimpleTooltip } from '@tanium/react-tooltip';
import { useIsOverflowing } from '@tanium/react-use-is-overflowing';

const tooltipModifiers: Modifiers = { preventOverflow: { boundariesElement: 'viewport' } };

export const SingleLineOption = <T extends unknown>(props: OptionProps<T>) => {
  const {
    children,
    className,
    cx,
    getStyles,
    label,
    isDisabled,
    isFocused,
    isSelected,
    innerProps,
  } = props;
  const [isOverflowing, overflowRef] = useIsOverflowing();

  return (
    <SimpleTooltip
      delayShowMs={TRUNCATED_TEXT_TOOLTIP_DELAY_MS}
      placement="top"
      content={isOverflowing && label}
      modifiers={tooltipModifiers}
    >
      {({ ref }) => (
        <div ref={ref}>
          <div
            ref={overflowRef}
            className={
              cx(
                css(getStyles('option', props), {
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                }),
                {
                  option: true,
                  'option--is-disabled': isDisabled,
                  'option--is-focused': isFocused,
                  'option--is-selected': isSelected,
                },
                className,
              ) as string
            }
            {...innerProps}
          >
            {children}
          </div>
        </div>
      )}
    </SimpleTooltip>
  );
};
